export default [
  {
    path: '/announcement/form/register',
    component: () => import('@/views/announcement/AnnouncementForm.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '온라인 부고장 만들기',
      isSearchHeader: false
    }
  },
  {
    path: '/announcement/:announcementNo',
    component: () => import('@/views/announcement/Announcement.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      isHome: true,
      titleName: '',
      isGlass: true,
      isAnnouncementShare: true,
      isAnnouncementKakaoShare: true
    }
  },
  {
    path: '/announcement/share/:announcementNo',
    component: () => import('@/views/announcement/Announcement.vue'),
    meta: {
      isHeader: true,
      isNav: false,
      isBack: true,
      titleName: '',
      isGlass: true,
      isAnnouncementShare: true,
      isAnnouncementKakaoShare: true
    }
  }
];
